import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Organizi8DataProvider } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ClearAndFetchFabricCreateGRNLotListing,
  ClearAndFetchFabricCreateGRNLotListingSuccess,
  ClearAndFetchTrimsCreateGRNLotListing,
  ClearAndFetchTrimsCreateGRNLotListingSuccess,
  ClearAndFetchFabricCreateGRNLotDetails,
  ClearAndFetchFabricCreateGRNLotDetailsSuccess,
  ClearAndFetchTrimsCreateGRNLotDetails,
  ClearAndFetchTrimsCreateGRNLotDetailsSuccess,
  CreateGRNActions,
  CreateGRNNoAction,
} from './create-grn.actions';
import { catchError, finalize, map, switchMap, take } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CreateGRNDBEffects {
  constructor(
    private actions$: Actions,
    private apiHelper: AppNotificationUtilClass,
    private organizi8DataProvider: Organizi8DataProvider,
    private translate: TranslateService,
  ) {}

  ClearAndFetchFabricCreateGRNLotListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchFabricCreateGRNLotListing>(CreateGRNActions.ClearAndFetchFabricCreateGRNLotListing),
      switchMap((action) =>
        from(this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.loading'))).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.fetchFabricCreateGRNLotListing(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchFabricCreateGRNLotListingSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_FABRIC_GRN_LOT_LISTING_ERROR]', error);
            return of(new CreateGRNNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchTrimsCreateGRNLotListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchTrimsCreateGRNLotListing>(CreateGRNActions.ClearAndFetchTrimsCreateGRNLotListing),
      switchMap((action) =>
        from(this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.loading'))).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.fetchTrimsCreateGRNLotListing(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchTrimsCreateGRNLotListingSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_TRIMS_GRN_LOT_LISTING_ERROR]', error);
            return of(new CreateGRNNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchFabricCreateGRNLotDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchFabricCreateGRNLotDetails>(CreateGRNActions.ClearAndFetchFabricCreateGRNLotDetails),
      switchMap((action) =>
        from(
          this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.getting_fabric_lot_details')),
        ).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.fetchFabricCreateGRNLotDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchFabricCreateGRNLotDetailsSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_FABRIC_GRN_LOT_DETAILS_ERROR]', error);
            return of(new CreateGRNNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchTrimsCreateGRNLotDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchTrimsCreateGRNLotDetails>(CreateGRNActions.ClearAndFetchTrimsCreateGRNLotDetails),
      switchMap((action) =>
        from(
          this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.getting_trims_lot_details')),
        ).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.fetchTrimsCreateGRNLotDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchTrimsCreateGRNLotDetailsSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_TRIMS_GRN_LOT_DETAILS_ERROR]', error);
            return of(new CreateGRNNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );
}
